export enum CryptoAssetType {
  Native = 0,
  Erc20 = 1,
}

export enum SLIP44 {
  BITCOIN = 0,
  BITCOIN_TESTNET = 1,
  ETHEREUM = 60,
}

export interface CryptoAssetTypeResponse {
  id: CryptoAssetType;
  name: string;
}

export interface CryptoAssetsBlockchainConfigurationResponse {
  chainId: number | null;
  slip44CoinType: number;
  name: string;
  rpcUrl: string;
  blockExplorerUrl: string;
  blockExplorerApiUrl: string | null;
  usesEIP1559: boolean;
  isDefaultLayer1: boolean;
  isDefaultLayer2: boolean;
}

export interface CryptoAssetSettingsResponse {
  allowPurchases: boolean;
  allowInApp: boolean;
  allowSell: boolean;
}

export interface CryptoAssetDTO {
  id: number;
  canonicalName: string;
  displayName: string;
  assetType: CryptoAssetTypeResponse;
  definitionAddress: string | null;
  decimalPrecision: number | null;
  blockchainConfiguration: CryptoAssetsBlockchainConfigurationResponse;
  settings: CryptoAssetSettingsResponse;
}

export interface CryptoAssetTraits {
  isBitcoin: boolean;
  isBrandErc20: boolean;
  isDefaultLayer1: boolean;
  isDefaultLayer2: boolean;
  isDefaultLayer2Native: boolean;
  isDigitalReward: boolean;
  isErc20: boolean;
  isEvm: boolean;
  isNative: boolean;
}

export interface CryptoAssetDisplay {
  decimalPrecision: number;
  name: string;
  symbol: string;
}

export interface CryptoAssetRoutingKey {
  assetType: CryptoAssetType;
  chainId: number | '_';
  slip44CoinType: number;
  value: string;
}

export interface CryptoAssetFee {
  cryptoAssetUniqueKey: string;
  decimalPrecision: number;
}

export interface CryptoAsset {
  asset: CryptoAssetDTO;
  display: CryptoAssetDisplay;
  fee: CryptoAssetFee;
  routingKey: CryptoAssetRoutingKey;
  traits: CryptoAssetTraits;
  uniqueKey: string;
}

interface WalletState {
  isImported: boolean;
  hasWallet: boolean;
  loading: boolean;
  error: boolean;
}

interface WalletError {
  coin: boolean;
  server: boolean;
}

interface CoinResponse {
  symbol: string;
  name: string;
  address: string;
  balance: string;
  balanceUsd: string;
  priceUsd: string;
  icon: string | null;
  canSendFunds: boolean;
}

interface Coin {
  useEthGas: boolean;
  priceUsd: string;
  coinAmt: string;
  coinLogo: string;
  hasError: boolean;
  usd: string;
  walletId: string;
  valid: boolean;
  cryptoAsset?: CryptoAsset | null;
}

type WalletCoins = Coin[];

interface EthWallet {
  id: string;
  name: string;
  icon: string;
  totalUSD: string;
  totalETH: string;
  valid: boolean;
  priceUsd: string;
}

export type { WalletCoins, CoinResponse, Coin, EthWallet, WalletState, WalletError };
